module.exports = __webpack_public_path__ + "static/img/newS-logo.c59d964f.png";